var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2.75C8.5 2.33579 8.16421 2 7.75 2C7.33579 2 7 2.33579 7 2.75V4H6.75C4.67894 4 3 5.67894 3 7.75V17.25C3 19.3211 4.67894 21 6.75 21H11.25C11.6642 21 12 20.6642 12 20.25C12 19.8358 11.6642 19.5 11.25 19.5H6.75C5.50736 19.5 4.5 18.4927 4.5 17.25V10H19.5V10.25C19.5 10.6642 19.8358 11 20.25 11C20.6642 11 21 10.6642 21 10.25V7.75C21 5.67894 19.3211 4 17.25 4H17V2.75C17 2.33579 16.6642 2 16.25 2C15.8358 2 15.5 2.33579 15.5 2.75V4H8.5V2.75ZM17.25 5.5C18.4927 5.5 19.5 6.50736 19.5 7.75V8.5H4.5V7.75C4.5 6.50736 5.50736 5.5 6.75 5.5H17.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7197 14.2197L15.0984 17.841C14.3951 18.5442 14 19.4981 14 20.4926V21.25C14 21.6642 14.3358 22 14.75 22H15.5074C16.5019 22 17.4558 21.6049 18.159 20.9016L21.7803 17.2803C22.6255 16.4351 22.6255 15.0649 21.7803 14.2197C20.9351 13.3745 19.5649 13.3745 18.7197 14.2197ZM16.159 18.9016L19.7803 15.2803C20.0397 15.0209 20.4603 15.0209 20.7197 15.2803C20.9791 15.5397 20.9791 15.9603 20.7197 16.2197L17.0984 19.841C16.6764 20.2629 16.1041 20.5 15.5074 20.5H15.5V20.4926C15.5 19.8959 15.7371 19.3236 16.159 18.9016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEdit);
export default __webpack_public_path__ + "static/media/calendar-edit.bd54c58c885fedcbec80fecb0fdd4177.svg";
export { ForwardRef as ReactComponent };